import parse from "html-react-parser";
import { motion } from "framer-motion";

import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";

import { anim } from "../Animations/utils";

import "react-quill/dist/quill.snow.css";

const animateInstruction = {
  initial: { x: "100%" },
  animate: {
    x: 0,
    transition: {
      duration: 0.4,
      ease: [0.165, 0.84, 0.44, 1],
    },
  },
  exit: {
    x: "100%",
    transition: { duration: 0.4, ease: [0.165, 0.84, 0.44, 1] },
  },
};

interface InstructionDialogProps {
  instruction: string;
  onDismiss: () => void;
  title?: string;
}

const InstructionDialog = (props: InstructionDialogProps) => {
  const { instruction, onDismiss, title } = props;

  return (
    <Dialog
      fullScreen
      open
      transitionDuration={0}
      component={motion.div}
      {...anim(animateInstruction)}
    >
      <DialogContent dividers className="p-0">
        <div className="p-5 d-flex flex-column align-items-center justify-content-center h-100">
          {title && (
            <DialogContentText
              className="text-center fw-bold"
              style={{
                fontSize: "5rem",
                color: "#000000",
                marginBottom: "6rem",
              }}
            >
              {title}
            </DialogContentText>
          )}
          <div
            style={{
              width: "90%",
            }}
          >
            <div className="ql-snow" style={{ width: "100%" }}>
              <div className="ql-editor">{parse(instruction || "")}</div>
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="p-5">
        <Button
          variant="contained"
          className="px-5 me-5 w-25"
          onClick={onDismiss}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InstructionDialog;
